export const fileToBase64 = (file: File): Promise<string | null> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const result = reader.result as string;
      const base64 = result.split(",")[1];
      if (!base64) {
        resolve(null);
        return;
      }
      resolve(base64);
    };
    reader.onerror = (error) => {
      reject(error);
    };
  });
};
